import React from 'react';
import PropTypes from 'prop-types';
import { connectStateResults, connectSearchBox } from 'react-instantsearch-dom';
import { Icon } from 'ck-ui';

const SearchBarHeader = ({ searchResults, onSearchEnter, toggleFocus, currentRefinement, refine }) => {
  const handleSubmit = (e) => {
    const input = e.target && e.target.querySelector('input');
    const hasProducts = searchResults && searchResults.nbHits !== 0;
    return onSearchEnter((input && input.value), hasProducts)(e);
  };

  return (
    <div className="ais-SearchBox">
      <form
        noValidate=""
        className="ais-SearchBox-form"
        action=""
        role="search"
        onSubmit={(event) => {
          event.preventDefault(); // Prevent form submission by default
          if (!currentRefinement || currentRefinement.trim() === '') return;
          handleSubmit(event); // Call the submit handler if the input is not empty
        }}
      >
        <input
          onFocus={toggleFocus(true)}
          type="text"
          placeholder="Search brands or products"
          className="ais-SearchBox-input"
          value={currentRefinement}
          onChange={event => refine(event.target.value)}
        />
        <button type="submit" title="Submit" className="ais-SearchBox-submit">
          <Icon className="ais-SearchBox-submitIcon" name="search" size="regular" />
        </button>
        {currentRefinement.length > 0 && (
          <button type="button" title="Reset" className="ais-SearchBox-reset" hidden="" onClick={() => refine('')}>
            <Icon className="ais-SearchBox-resetIcon" name="cross" size="regular" />
          </button>
        )}
      </form>
    </div>
  );
};

SearchBarHeader.propTypes = {
  onSearchEnter: PropTypes.func.isRequired,
  toggleFocus: PropTypes.func.isRequired,
  currentRefinement: PropTypes.string.isRequired,
  refine: PropTypes.func.isRequired,
  searchResults: PropTypes.object
};

SearchBarHeader.defaultProps = {
  searchResults: null
};

const SearchBarHeaderContainer = connectSearchBox(connectStateResults(SearchBarHeader));

export { SearchBarHeaderContainer };
